import React from "react";
import { ROWS_PER_PAGE_OPTIONS } from "$utils/constants";

interface RowsPerPageProps {
  rowsPerPage: number;
  setRowsPerPage: (rows: number) => void;
  label?: string;
}

const RowsPerPage = ({
  rowsPerPage,
  setRowsPerPage,
  label,
}: RowsPerPageProps) => {
  const handleRowsChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRowsPerPage(Number(event.target.value));
  };

  const labelText = label || "Lignes par page";

  return (
    <div>
      <label htmlFor="rows-per-page">{labelText}: </label>
      <select
        id="rows-per-page"
        value={rowsPerPage}
        onChange={handleRowsChange}
        style={{ padding: "8px" }}
      >
        {ROWS_PER_PAGE_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};

export default RowsPerPage;
